const currency = $('body').attr('data-currency');

$(window).on('scroll', function () {
  $('.collectionMainContainer').each(function () {
    const containerTop = $(this).offset().top;
    const containerBottom = containerTop + $(this).outerHeight();
    const scrollTop = $(window).scrollTop();
    const windowHeight = $(window).height();

    // Check if container is in the viewport
    if (scrollTop + windowHeight > containerTop && scrollTop < containerBottom) {
      $(this).addClass('new-class');
      $('body').addClass('scroll_active');
    } else {
      $(this).removeClass('new-class');
      $('body').removeClass('scroll_active');
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  // Exclude assembly videos from autoplay
  const videos = document.querySelectorAll(
    "video:not(.assembly-video)"
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const video = entry.target;

        if (entry.isIntersecting) {
          video.play().catch(() => {
            video.muted = true;
            video.play().catch(() => {});
          });
        } else {
          video.pause();
        }
      });
    },
    {
      threshold: 0.5
    }
  );
  videos.forEach((video) => observer.observe(video));
});


$(document).ready(function(){

  $(document).on('mouseover', '.menu.header_item .menu-link .child_menu', function(){
    if(!$(this).hasClass('hoveron')){
      $(this).addClass('hoveron');
    }
  })

  $(document).on('mouseout', '.menu.header_item .menu-link .child_menu', function(){
    if($(this).hasClass('hoveron')){
      $(this).removeClass('hoveron');
    }
  })

  $(document).on('mouseover', '.spf-product__swatchs.spf-color-swatch .spf-product__swatch, .product_tab_variants label', function(){
    $(this).trigger('click');

    var variantID = $(this).data('variant-id');
    var $productCard = $(this).closest('.spf-product-card');

    // ✅ GET ORIGINAL PRICE FROM SWATCH
    var originalPrice = $(this).attr('price'); // e.g. 1795

    $('.hidden-products-collection-wrap .hidden-product-item').each(function() {
      var dataVid = $(this).data('vid');
      var check_sale = $(this).data('sale');
     
      if (dataVid == variantID) {
        var salePrice = $(this).data('sale-price');
        if (originalPrice > salePrice && originalPrice > 0) {
          $productCard.find('.spf-product-card__oldprice.jjjjjj.money').text(currency + parseFloat(originalPrice).toFixed(2));
          $productCard.find('.spf-product-card__oldprice.jjjjjj.money').show();
        }else{
          $productCard.find('.spf-product-card__oldprice.jjjjjj.money').text('');
          $productCard.find('.spf-product-card__oldprice.jjjjjj.money').hide();
        }

        var salePercent = $(this).data('sale-percent');
        var discountAmount = (salePrice * salePercent) / 100;
        var discountedPrice = salePrice - discountAmount;
        
        var discountedPriceFormatted = (discountedPrice / 100).toFixed(2);

        if(check_sale == true && salePercent > 0){
          $productCard.find('.spf-product-card__inner .badge2.badgeFilter').text(salePercent + '% off');
          $productCard.find('.spf-product-card__inner .badge2.badgeFilter').show();
        }else{
          $productCard.find('.spf-product-card__inner .badge2.badgeFilter').hide();
        }
        
        $productCard.find('.spf-product-card__saving').text(salePercent + '% off');
        $productCard.find('.spf-product-card__saleprice.money').text(currency + discountedPriceFormatted);
      }
    });

  });


  $('.nav-grid-item').hover(
    function () {
      // Mouse enter
      $('.nav-grid-item .nav-slide-content h3 a').removeClass('add-before');
      $(this).find('.nav-slide-content h3 a').addClass('add-before');
    },
    function () {
      // Mouse leave
      $(this).find('.nav-slide-content h3 a').removeClass('add-before');
    }
  );

});


function applyColorSwatches() {
  if ($('#ProductGridContainer').length > 0) {
    var colors_list = $('.collectionMainContainer').attr('data-colors');

    if (colors_list && colors_list !== 'undefined' && colors_list !== null) {
      var colorArray = colors_list.split(',').map(function(item) {
        var parts = item.split('-');
        return {
          name: parts[0].trim().toLowerCase(),
          hex: parts[1].trim()
        };
      });

      var $colorFilterBox = $('#gf-tree .gf-filter-contents .gf-option-block .gf-block-content .color-filter-gf-box');

      if ($colorFilterBox.length > 0) {
        $colorFilterBox.find('li').each(function () {
          var color_name = $(this).attr('data-color');

          if (color_name && color_name !== 'undefined') {
            var match = colorArray.find(function (color) {
              return color.name === color_name.trim().toLowerCase();
            });

            if (match) {
              $(this).find('.gf-option-value')
                     .css('background-color', match.hex)
                     .addClass('colorSwatchValue');
            }
          }
        });
      }
    }
  }
}


$(window).on('load', function() {
  $('.maincollectionGrid').addClass('show');
  $('.collectionMainContainer .collection-loader').addClass('hide');

  var search_count = 0;

  if($('.template-search .search-product-grid-wrapper').length > 0){
    search_count = $('.template-search .search-product-grid-wrapper .search-product-wrap-inner div#gf-grid span.gf-summary b').text();

    if(search_count > 0){
      $('.template-search__header .template-search__header-content span.search-result-total').text(search_count);
      $('.template-search__header .template-search__header-content .search-header-counter').addClass('showing');
    }
    
  }

  setTimeout(function(){
    /* if ($('div#ProductGridContainer .gf-filter-selection .sort-by').length > 0) {
      if (!$('div#ProductGridContainer .gf-filter-selection .sort-by').hasClass('limit-by')) {
        $('<span class="sortingLabel">Sort By</span>').insertBefore(
          $('div#ProductGridContainer .gf-filter-selection .sort-by').find('.sort-by-toggle')
        );
      }
    } */
    
  }, 1000);
});


window.addEventListener('globoFilterRenderCompleted', function () {
  // If swatches already applied, don't re-run
  if ($('.gf-option-value.colorSwatchValue').length > 0) {
    return;
  }

  applyColorSwatches();

  if ($('.hidden-products-collection-wrap').length > 0 && $('.spf-product-card').length > 0) {
    const hiddenItems = $('.hidden-products-collection-wrap .hidden-product-item');
    const market = $('.hidden-products-collection-wrap').attr('data-market');

    $('.spf-product-card').each(function () {
      const $card = $(this);
      const data_id = $card.attr('data-pid');

      if (data_id && data_id !== 'undefined' && data_id !== null) {
        const $hidden = hiddenItems.filter(`[data-pid="${data_id}"]`);

        if ($hidden.length) {
          let sale_price = parseFloat($hidden.attr('data-sale-price')) / 100 || 0;
          let comp_price = parseFloat($hidden.attr('data-comp-price')) / 100 || 0;
          const check_if_sale = $hidden.attr('data-sale') === 'true';
          const sale_percent = parseFloat($hidden.attr('data-sale-percent')) || 0;
          const sale_title = $hidden.attr('data-sale-title') || '';

          if(sale_percent > 0 && check_if_sale == true){
            $(this).find('span.badge.badge2.badgeFilter').html(sale_percent+'% off');
            $(this).find('span.badge.badge2.badgeFilter').show();
          }else{
            $(this).find('span.badge.badge2.badgeFilter').hide();
          }

          if (comp_price > 0) {
            // Compare at price exists → normal sale product
            $card.find('.spf-product-card__oldprice').html(currency+`${comp_price.toFixed(2)}`);
            
            $card.find('.spf-product-card__saleprice').html(currency+`${sale_price.toFixed(2)}`);
            $card.find('.spf-product-card__saving').html(currency+`${sale_percent}% off`);
          } else if (check_if_sale) {
            // Custom sale calculation via metafield
            const discountAmount = sale_price * (sale_percent / 100);
            const final_price = sale_price - discountAmount;
            if(sale_price > 0){
              $card.find('.spf-product-card__oldprice').html(currency+`${sale_price.toFixed(2)}`);
            }
            $card.find('.spf-product-card__saleprice').html(currency+`${final_price.toFixed(2)}`);
            $card.find('.spf-product-card__saving').html(currency+`${sale_percent}% off`);
          }else{
            $card.find('.spf-product-card__oldprice').hide();
          }

          // Optional: Add sale title tooltip or badge
          if (sale_title) {
            $card.attr('data-sale-title', sale_title);
          }
        }
      }

      if(market == 'canada'){
        $(this).find('.spf-product__swatchs .spf-product__swatch[data-option-value="Ash"]').hide();
        $(this).find('.spf-product__swatchs .spf-product__swatch[data-option-value="Nightfall"]').hide();
      }

    });

  }
});

// 22may
function updateMemorialSaleBar(cartTotal, cart) {

  const saleBar = document.querySelector(".cart_drawer_free_shipping_bar");
  const currencyCode = $('body').attr('data-currency-code').toUpperCase();
  const isUKMarket = currencyCode === 'GBP' || window.location.hostname.indexOf('uk.') === 0;
  const liquidGoal = Number(saleBar?.dataset.saleGoal) || 0;
  const maxGoal = liquidGoal || (isUKMarket ? 650 : 750);
  const defaultAwayTemplate = isUKMarket
    ? `You're £__REMAIN__ away from <strong>£50 OFF</strong>`
    : `You're $__REMAIN__ away from <strong>$100 OFF</strong>`;
  const defaultUnlockedMessage = isUKMarket
    ? `🎉 Congratulations! You've unlocked <strong>£50 OFF</strong>`
    : `🎉 Congratulations! You've unlocked <strong>$100 OFF</strong>`;
  const liquidMessageMatchesMarket = Boolean(
    saleBar?.dataset.saleGoal &&
    ((isUKMarket && liquidGoal === 650) || (!isUKMarket && liquidGoal === 750))
  );
  const awayTemplate = (liquidMessageMatchesMarket && saleBar?.dataset.awayTemplate) || defaultAwayTemplate;
  const unlockedMessage = (liquidMessageMatchesMarket && saleBar?.dataset.unlockedMessage) || defaultUnlockedMessage;

  const fill = document.getElementById("saleProgressFill");
  const icon = document.getElementById("saleProgressIcon");
  const message = document.getElementById("progressMessage");
  const congratsBox = document.getElementById("saleCongratsBox");
  const milestoneLabel = document.querySelector(".milestone-label.milestone-150");
  const almostThereText = congratsBox ? congratsBox.querySelector("p") : null;

  if (!fill || !icon || !message) return;

  if (milestoneLabel) {
    milestoneLabel.textContent = isUKMarket ? '£50 off' : '$100 off';
  }

  if (almostThereText) {
    almostThereText.innerHTML = isUKMarket
      ? `<span class="cong-text-icon"> <img src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Check.svg?v=1779447072" alt="Icon"> </span> <strong>Almost there!</strong> Spend £650 to get £50 off.`
      : `<span class="cong-text-icon"> <img src="https://cdn.shopify.com/s/files/1/0745/0876/3427/files/Check.svg?v=1779447072" alt="Icon"> </span> <strong>Almost there!</strong> Spend $750 to get $100 off.`;
  }

  /* Progress Percentage */
  let fillPercent = (cartTotal / maxGoal) * 100;

  fillPercent = Math.max(0, Math.min(fillPercent, 100));

  /* Apply progress */
  fill.style.width = `${fillPercent}%`;
  icon.style.left = `${fillPercent}%`;

  /* Dynamic market messages */

  if (cartTotal < maxGoal) {
    const remain = Math.max(0, Math.ceil(maxGoal - cartTotal));
    message.innerHTML = awayTemplate.replace('__REMAIN__', remain.toLocaleString());

    if (congratsBox) {
      congratsBox.style.display = "flex";
    }

  }else {
    message.innerHTML = unlockedMessage;
    if (congratsBox) {
      congratsBox.style.display = "none";
    }
  }
}

/* Fetch Shopify Cart */
function initMemorialProgressBar() {
  const saleBar = document.querySelector(
    '.cart_drawer_free_shipping_bar'
  );

  if (!saleBar) return;

  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      /* Shopify returns cents */
      let cartTotal = cart.total_price / 100;

      let itemsTotalPrice = cart.items_subtotal_price / 100;

      updateMemorialSaleBar(itemsTotalPrice);

    })
    .catch(error => {
      console.log('Cart Error:', error);
    });

}

/* Initial Load */
/* document.addEventListener("DOMContentLoaded", function () {
  initMemorialProgressBar();
}); */

$(document).one('click', '.cart-button-2', function () {
  initMemorialProgressBar();
});

/* Recalculate after ANY cart AJAX update */

(function() {

  const originalFetch = window.fetch;

  window.fetch = async function() {

    const response = await originalFetch.apply(this, arguments);

    const url = arguments[0];

    if (
      typeof url === 'string' &&
      (
        url.includes('/cart/add') ||
        url.includes('/cart/change') ||
        url.includes('/cart/update') ||
        url.includes('/cart/clear')
      )
    ) {

      setTimeout(() => {
        initMemorialProgressBar();
      }, 300);

    }

    return response;
  };

})();

document.addEventListener('click', function(e){
    if(e.target.closest('.gf-close-canvas')){
        if(window.globofilter && globofilter.toggleCanvas){
            globofilter.toggleCanvas();
        }
    }
});


window.addEventListener('scroll', function() {
  const elements = document.querySelectorAll('.top-announcement-wrapper, .min-cart-static');

  elements.forEach(function(element) {
      if (window.scrollY >= 50) {
          element.classList.add('new-height');
      } else {
          element.classList.remove('new-height');
      }
  });
}); 

const announcement = document.querySelector('.top-announcement-wrapper');
const miniCart = document.querySelector('#mini-cart');

function toggleMiniCartHeight() {
    if (!announcement || !miniCart) return;

    const rect = announcement.getBoundingClientRect();

    // Add class only after the announcement has completely left the viewport
    if (rect.bottom <= 0) {
        miniCart.classList.add('new-height');
    } else {
        miniCart.classList.remove('new-height');
    }
}

window.addEventListener('scroll', toggleMiniCartHeight);
window.addEventListener('load', toggleMiniCartHeight);


/* document.addEventListener('DOMContentLoaded', () => {
  const timers = document.querySelectorAll('countdown-timer');

  timers.forEach(timer => {
    const year = parseInt(timer.dataset.year);
    const month = parseInt(timer.dataset.month) - 1; // JS months are 0-based
    const day = parseInt(timer.dataset.day);
    const hour = parseInt(timer.dataset.hour);
    const minute = parseInt(timer.dataset.minute);
    const hideAfterExpiry = timer.dataset.hideTimer === "true";
    const completeMessage = timer.dataset.completeMessage || "Offer expired!";

    const targetDate = new Date(year, month, day, hour, minute);

    const daysEl = timer.querySelector('[date-days-placeholder]');
    const hoursEl = timer.querySelector('[date-hours-placeholder]');
    const minutesEl = timer.querySelector('[date-minutes-placeholder]');
    const secondsEl = timer.querySelector('[date-seconds-placeholder]');
    const messageEl = timer.querySelector('[data-message-placeholder]');

    let interval; // declare first so it's available inside updateTimer()

    function updateTimer() {
      const now = new Date();
      const diff = targetDate - now;

      if (diff <= 0) {
        if (hideAfterExpiry) {
          timer.style.display = 'none';
        } else if (messageEl) {
          messageEl.textContent = completeMessage;
        }
        clearInterval(interval); // now interval exists
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      if (daysEl) daysEl.textContent = days.toString().padStart(2, '0');
      if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
      if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
      if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
    }

    updateTimer(); // run immediately once
    interval = setInterval(updateTimer, 1000); // assign after definition
  });
}); */


document.addEventListener('DOMContentLoaded', function () {
  function initLazyVideos(selector) {
    const wrappers = document.querySelectorAll(selector);

    function loadAndPlay(wrapper) {
      const video = wrapper.querySelector('video');
      const source = video.querySelector('source');
      const videoUrl = wrapper.getAttribute('data-video');

      if (!source.getAttribute('src')) {
        source.setAttribute('src', videoUrl);
        video.load();
        video.play().catch(() => {
          // Autoplay might be blocked on some browsers (esp. Safari without muted).
          console.log('Autoplay blocked, user interaction required.');
        });
      }
    }

    function checkVisibility() {
      wrappers.forEach((wrapper) => {
        const rect = wrapper.getBoundingClientRect();
        const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
        if (isVisible) loadAndPlay(wrapper);
      });
    }

    checkVisibility(); // covers "already visible on load" case
    window.addEventListener('scroll', checkVisibility, { passive: true });
  }

  initLazyVideos('.video_content');
  initLazyVideos('.lazy-video');
});


$(document).ready(function () {

  if(window.outerWidth < 767){
    const shipping = new Swiper('.icon_text_wrapper',{
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: '.shipping-btn-next',
        prevEl: '.shipping-btn-prev'
      }
      
    });
  }


  var windowWidth1 = window.innerWidth;
  if (windowWidth1 <= 1024) {
    var $mobileMenuHeader = $('.mobile_menu_header');
    var $mainPanel = $('.nb_main-panel');
    var $shopNowPanel = $('.nb_shop-now-panel');
    var $ourBrandPanel = $('.nb_our-brands-panel');
    var $subPanel = $('.nb_sub-panel');
    var $submenuTitle = $('.nb_submenu-title');

    // Open Shop Now panel
    $('.nb_open-shop-now').on('click', function (e) {
      e.preventDefault();
      $mainPanel.removeClass('nb_active');
      $ourBrandPanel.removeClass('nb_active');
      $shopNowPanel.addClass('nb_active');
      $mobileMenuHeader.addClass('nb_mmh_active');
    });


    // Open Brands panel
    $('.nb_open-our-brands').on('click', function (e) {
      e.preventDefault();
      $mainPanel.removeClass('nb_active');
      $shopNowPanel.removeClass('nb_active');
      $ourBrandPanel.addClass('nb_active');
      $mobileMenuHeader.addClass('nb_mmh_active');
    });

    // Back to Main
    $('.nb_back-to-main').on('click', function () {
      $shopNowPanel.removeClass('nb_active');
      $ourBrandPanel.removeClass('nb_active');
      $mainPanel.addClass('nb_active');
      $mobileMenuHeader.removeClass('nb_mmh_active');
    });

    // Open Submenu Panel (just show pre-rendered submenu)
    
    $(document).on('click', '.nb_open-submenu', function (e) {
      e.preventDefault();
    
      var $this = $(this);
      var type = $this.data('type');
      var $submenu = $('.nb_submenu-' + type);
    
      if (!type) return;
    
      // If this is already active, close it
      if ($this.hasClass('nb_submenu_li_active')) {
        $this.removeClass('nb_submenu_li_active');
        $submenu.slideUp();
      } else {
        // Close all other submenus and remove active classes
        $('.nb_open-submenu').removeClass('nb_submenu_li_active');
        $('.nb_submenu-items').slideUp();
    
        // Open the clicked one
        $this.addClass('nb_submenu_li_active');
        $submenu.slideDown();
      }
    
      // Update submenu title
      $('.nb_submenu-title').text(
        type === 'category' ? 'Shop by Category' : 'Shop by Size'
      );
    
      // Ensure sub panel is visible
      $('.nb_sub-panel').addClass('nb_active');
    });

    

    // Back to Shop Now panel
    $('.nb_back-to-shop-now').on('click', function () {
      $subPanel.removeClass('nb_active');
      $shopNowPanel.addClass('nb_active');
    });
  }
});




 document.addEventListener('click', function(e){

  const drawer      = document.getElementById('drawer');
  const overlay     = document.getElementById('overlay');
  const hamBtn      = document.querySelector('.ham-btn');

  const brandsPanel = document.getElementById('brandsPanel');
  const aboutPanel  = document.getElementById('aboutPanel');

  const mainPanel   = document.getElementById('mainPanel');

  /* DESKTOP COUNTRY */
  const flagBtn     = document.getElementById('flagBtn');
  const countryPop  = document.getElementById('countryPop');

  /* MOBILE COUNTRY */
  const flagBtnmob    = document.querySelector('.flag-dropdown-mobile .selected');
  const countryPopmob = document.querySelector('.flag-dropdown-mobile .options');

  /* =========================
     HAMBURGER
  ========================= */

  const hamClick = e.target.closest('.ham-btn');

  if (hamClick && drawer && overlay) {

    const isOpen = drawer.classList.contains('on');

    if (isOpen) {

      drawer.classList.remove('on');
      overlay.classList.remove('on');

      hamClick.classList.remove('open');

      brandsPanel?.classList.remove('on');
      aboutPanel?.classList.remove('on');
      mainPanel?.classList.remove('out');

      if (flagBtn && countryPop) {
        flagBtn.classList.remove('open');
        countryPop.classList.remove('on');
      }

      if (flagBtnmob && countryPopmob) {
        flagBtnmob.classList.remove('open');
        countryPopmob.classList.remove('on');
      }

      document.body.style.overflow = '';

    } else {

      drawer.classList.add('on');
      overlay.classList.add('on');

      hamClick.classList.add('open');

      document.body.style.overflow = 'hidden';
    }

    return;
  }

  /* =========================
     OVERLAY CLOSE
  ========================= */

  if (e.target.id === 'overlay') {

    drawer?.classList.remove('on');
    overlay?.classList.remove('on');

    document.querySelectorAll('.ham-btn').forEach(btn => {
      btn.classList.remove('open');
    });

    brandsPanel?.classList.remove('on');
    aboutPanel?.classList.remove('on');
    mainPanel?.classList.remove('out');

    if (flagBtn && countryPop) {
      flagBtn.classList.remove('open');
      countryPop.classList.remove('on');
    }

    if (flagBtnmob && countryPopmob) {
      flagBtnmob.classList.remove('open');
      countryPopmob.classList.remove('on');
    }

    document.body.style.overflow = '';

    return;
  }

  /* =========================
     BRANDS PANEL
  ========================= */

  const brandsBtn = e.target.closest('#brandsBtn');

  if (brandsBtn && brandsPanel && mainPanel) {

    const isOpen = brandsPanel.classList.contains('on');

    if (isOpen) {

      brandsPanel.classList.remove('on');
      mainPanel.classList.remove('out');

    } else {

      brandsPanel.classList.add('on');
      aboutPanel?.classList.remove('on');
      mainPanel.classList.add('out');
    }

    return;
  }

  /* =========================
     ABOUT PANEL
  ========================= */

  const aboutBtn = e.target.closest('#aboutBtn');

  if (aboutBtn && aboutPanel && mainPanel) {

    const isOpen = aboutPanel.classList.contains('on');

    if (isOpen) {

      aboutPanel.classList.remove('on');
      mainPanel.classList.remove('out');

    } else {

      aboutPanel.classList.add('on');
      brandsPanel?.classList.remove('on');
      mainPanel.classList.add('out');
    }

    return;
  }

  /* =========================
     BACK BUTTON
  ========================= */

  const backBtn = e.target.closest('.back-btn');

  if (backBtn) {

    brandsPanel?.classList.remove('on');
    aboutPanel?.classList.remove('on');
    mainPanel?.classList.remove('out');

    return;
  }

  /* =========================
     DESKTOP COUNTRY DROPDOWN
  ========================= */

  const flagClick = e.target.closest('#flagBtn');

  if (flagClick && flagBtn && countryPop) {

    const isOpen = flagBtn.classList.contains('open');

    if (isOpen) {

      flagBtn.classList.remove('open');
      countryPop.classList.remove('on');
      flagBtn.setAttribute('aria-expanded', 'false');

    } else {

      flagBtn.classList.add('open');
      countryPop.classList.add('on');
      flagBtn.setAttribute('aria-expanded', 'true');
    }

    return;
  }

/* =========================
    MOBILE COUNTRY DROPDOWN
========================= */
const mobileDropdown = document.querySelector('.flag-dropdown-mobile');
const mobileFlagClick = e.target.closest('.flag-dropdown-mobile');

if (mobileFlagClick && mobileDropdown && countryPopmob) {

    const isOpen = mobileDropdown.classList.contains('open');

    if (isOpen) {

        mobileDropdown.classList.remove('open');
        countryPopmob.classList.remove('on');

    } else {

        mobileDropdown.classList.add('open');
        countryPopmob.classList.add('on');
    }

    return;
}
  /* =========================
    OUTSIDE DESKTOP COUNTRY CLICK
  ========================= */

  if (
    flagBtn &&
    countryPop &&
    countryPop.classList.contains('on') &&
    !countryPop.contains(e.target) &&
    !flagBtn.contains(e.target)
  ){
    flagBtn.classList.remove('open');
    countryPop.classList.remove('on');
    flagBtn.setAttribute('aria-expanded', 'false');
  }

  /* =========================
    OUTSIDE MOBILE COUNTRY CLICK
  ========================= */

  if(
    mobileDropdown &&
    countryPopmob &&
    countryPopmob.classList.contains('on') &&
    !mobileDropdown.contains(e.target)
  ){
    mobileDropdown.classList.remove('open');
    countryPopmob.classList.remove('on');
  }

});


// Klaviyo Pop-up handler for announcement banner
$(document).on('click', '.announcement_pop_up:not(.active)', function () {
  window._klOnsite = window._klOnsite || [];

  const isMobile = $(window).width() <= 767;
  const desktopFormId = 'VpvAWy'; // Desktop Klaviyo Form ID
  const mobileFormId = 'Tx3H93';  // Mobile Klaviyo Form ID
  // const $button = $(this);

  // Open correct form based on screen width
  if (isMobile) {
    window._klOnsite.push(['openForm', mobileFormId]);
  } else {
    window._klOnsite.push(['openForm', desktopFormId]);
  }
  
  // $button.addClass('active');
  
});

window.addEventListener("klaviyoForms", function(e) {
  if (e.detail.type == 'open') {
    $('.announcement_pop_up').addClass('active');
  }
  if (e.detail.type == 'close') {
    $('.announcement_pop_up').removeClass('active');
  }
});


jQuery(document).ready(function ($) {

  $('.faq_question_grid h3').click(function(){
    var height_paragraph = $(this).parents('.faq_question_grid').find('.faq_answer_ p').height();
    var height_div = $(this).parents('.faq_question_grid').find('.faq_answer_').height();
    if(height_div > 0)
    {
      $(this).parents('.faq_question_grid').find('.faq_answer_').css('height',"0px"); 
    }
    else
    {
      $(this).parents('.faq_question_grid').find('.faq_answer_').css('height',height_paragraph+"px"); 
    }
    $(this).parents('.faq_question_grid').toggleClass('active');
    
  }) 


  $('.sticky-checkout-button-wrapper button').on('click', function(e) {
    e.preventDefault();

    const $targetBtn = $('.cart-customize-layout-wrapper .cart-items .cart-footer-2 .cartCheckoutBtnWrapper .checkoutBtngrid input[type="submit"]');

    if ($targetBtn.length) {
      // Ensure visibility and enabled state
      if (!$targetBtn.prop('disabled') && $targetBtn.is(':visible')) {
        $targetBtn.trigger('click');
      } else {
        // Fallback using native click if jQuery trigger fails
        $targetBtn[0].click();
      }
    } else {
      console.log('Target checkout button not found.');
    }
  });

  const isMobile = $(window).width() <= 767;

  const desktopFormId = 'VpvAWy'; // Correct desktop form
  const mobileFormId = 'Tx3H93';  // Correct mobile form

  const $desktopToggle = $(".klaviyo-popup-toggle");
  const $mobileToggle = $("#klaviyo-toggle-btn-mobile");
  
  // Check and control visibility of teaser buttons
  setTimeout(function () {
    const teaserSelectors = [
      'button.needsclick.kl-teaser-TmtFGj',
      'button.needsclick.kl-teaser-WSys7i',
      'button.needsclick.kl-teaser-S9Zwe4'
    ];

    let teaserVisible = false;
    teaserSelectors.forEach(sel => {
      if ($(sel).length > 0) {
        teaserVisible = true;
      }
    });

    if (teaserVisible) {
      $(".button-toggle-main-wrap").hide();
    } else {
      $(".button-toggle-main-wrap").show();
    }
  }, 1000);
  
  
  // Desktop popup open trigger
  if ($desktopToggle.length > 0 && !isMobile) {
    $desktopToggle.on("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', desktopFormId]);
      $(this).slideUp();
    });
  }

  // Mobile popup open trigger
  if ($mobileToggle.length > 0 && isMobile) {
    $mobileToggle.on("click", function () {
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', mobileFormId]);
      $(this).removeClass('anime');
    });
  }
  
  // Handle close button: show toggle again
  $(document).on('click', 'button.klaviyo-close-form', function () {
    setTimeout(function () {
      if (isMobile) {
        if ($(`button.kl-teaser-${mobileFormId}`).length > 0) {
          $(`button.kl-teaser-${mobileFormId}`).addClass('anime');
          $mobileToggle.hide();
        } else {
          $mobileToggle.addClass('anime');
        }
      } else {
        $desktopToggle.slideDown();
      }
    }, 400);
  });
  
  // Handle form submit: show toggle again
  $(document).on('click', 'form.klaviyo-form button[type="submit"]', function () {
    setTimeout(function () {
      if (isMobile) {
        $mobileToggle.addClass('anime');
        $(`button.kl-teaser-${mobileFormId}`).addClass('anime');
      } else {
        $desktopToggle.slideDown();
      }
    }, 400);
  });
  
  // Teaser click handlers
  $(document).on('click', `button.kl-teaser-${desktopFormId}`, function () {
    $desktopToggle.slideUp();
  });

  $(document).on('click', `button.kl-teaser-${mobileFormId}`, function () {
    $mobileToggle.hide().removeClass('anime');
  });

  // Form submit success example (if needed)
  document.addEventListener("klaviyoForms", function (e) {
    if (e.detail.type === "submitSuccess" && e.detail.formId === "T3s9Xx") {
      console.log("Specific Klaviyo form submitted!");
      const form = document.querySelector('.klaviyo-form-T3s9Xx');
      if (form) form.classList.add('formSub');
    }
  });


  $('.w-commerce-commercecartopenlink').click(function(){
    $('.cart_drawer').addClass('active_cart_drawer');
  });

  $(document).on('click','.close-button', function(){
    $('.cart_drawer').removeClass('active_cart_drawer');
  })

  $(document).on('click', '.w-commerce-commercecartcontaineroverlay', function(){
    $('.cart_drawer').removeClass('active_cart_drawer');
  })

  var total_height = $('.header_container').innerHeight();
  var nav_height= $('.header_navigation').height();
  var reduce_height = total_height - nav_height;
  var top_height = reduce_height/2;

  var nav_child_space = nav_height + top_height;
  $('ul.menu.dropdown-child').css('top',nav_child_space+"px");

  if(window.innerWidth < 767){
    var announcement_height = $('.announcement_bar_container').innerHeight();
    var header_height = $('.header_container').innerHeight();
    var totl_height = announcement_height + header_height;
  // $('.header_mobile_nav ul.menu.header_item').css('top',totl_height+"px");
  }else if(window.innerWidth > 768 && window.innerWidth < 1024 ){
    var announcement_height = $('.announcement_bar_container').innerHeight();
    var header_height = $('.header_container').innerHeight();
    var totl_height = announcement_height + header_height;
    // $('.header_mobile_nav ul.menu.header_item').css('top',totl_height+"px");
  }

  $('.burger_icon img').click(function(){
    $(this).parents('.header_mobile_nav').find('.mobile_menu_header').toggleClass('active_nav');
  })

  $('.mobile_close_icon').click(function(){
    $('.mobile_menu_header').removeClass('active_nav');
    $('.burger_icon img').removeClass('active_icon');
  })

  $('.header_mobile_nav .menu-link').click(function(){

    $(this).find('.dropdown-child').toggleClass('mobile_nav_active');
    $(this).toggleClass('active_sub_menu');

    var inner_height = $('.sub-menu-link').height();
    if($(this).find('.dropdown-child').hasClass('mobile_nav_active')){
      $(this).find('.dropdown-child').css('height','108px');
    }else{
      $(this).find('.dropdown-child').css('height',0);
    }

  })

});


const $stickyATC = $(".sticky-atc-wrapper");
const $productMenu = $("section.pdp-menu.flex.wf-section.product_menu_section.visible");

const $button = $(".custom_product_temp .product_container .add-to-cart-button");
const $footer = $(".template-product .new_footer_container");

if (($stickyATC.length || $productMenu.length) && $button.length && $footer.length) {

  $(window).on("scroll", function () {

    const buttonRect = $button[0].getBoundingClientRect();
    const footerTop = $footer.offset().top;
    const viewportBottom = $(window).scrollTop() + $(window).height();

    // Show only after the whole button is above the viewport
    const shouldShow = buttonRect.bottom <= 0 && viewportBottom < footerTop;

    $stickyATC.toggleClass("is-visible", shouldShow);
    $productMenu.toggleClass("is-visible", shouldShow);

  });

  // Run once on page load
  $(window).trigger("scroll");
}